<div class="scanner-container">
  <video
    class="rounded-xl"
    #scanner
    id="scanner"
  ></video>
  <div class="overlay"></div>
</div>
